/**
 * @file 获取学员列表
 * @author liudy
 * @see http://api.umucdn.cn/project/106/wiki
 */

import Api from '../../path';
import { PollType } from '@umu/umu-types';
import { fetchData, fetchDataSync } from '@umu/umu-fetch';

export enum FilterUserType {
    ALL = '0',
    TEACHER = '1',
    STUDENT = '2',
}

export interface IGetPullUserListInput {
    parent_id: number; // int 作业问卷ID
    parent_type: PollType; // int 1、保存作业多维度评价问卷模板 2、保存作业多维度评价问卷
    obj_id: number; // int 评价对象ID，比如学生提交作业的homework_id
    page: number; // int
    size: number; // int
    role_type?: FilterUserType;
    get_score?: number; // int 1、获取分数 0、不获取分数
}

export interface IPollUserInfo extends IUserBaseInfo {
    score?: string;
}

// tslint:disable-next-line:max-line-length
export const getPollUserList = (data: IGetPullUserListInput): Promise<IListResponse<IPollUserInfo>> => {
    return fetchData(Api.POLL_USER_LIST, data).then((res: IListResponse<IPollUserInfo>) => {
        return res;
    });
};

export const getPollUserListSync = fetchDataSync(getPollUserList);
